import { component } from 'picoapp';
import Glide from '@glidejs/glide';

export default component((node) => {
  let glide;

  const init = () => {
    const carousel = node.querySelector('.js-related-articles');

    glide = new Glide(carousel, {
      type: 'carousel',
      startAt: 0,
      perView: 3,
      gap: 34,
      rewind: false,
      animationDuration: 400,
      breakpoints: {
        1100: {
          perView: 2,
        },
        680: {
          perView: 1,
          gap: 34,
        }
      }
    });

    glide.mount();
  };

  init();
});
